import {
  Space,
  Table as AntdTable,
  TableColumnType as AntdTableColumnType,
  TablePaginationConfig,
  TableProps as AntdTableProps,
} from 'antd';
import { useEffect } from 'react';
import { FilterValue, SorterResult, TableCurrentDataSource } from 'antd/lib/table/interface';

export type TableColumnType<T> = Omit<AntdTableColumnType<T>, 'key'> & {
  key: string;
  exportValue?: (item: T) => string;
};

const DEFAULT_PAGE_SIZE = 10;

const DEFAULT_PAGE_SIZE_OPTIONS: string[] = ['10', '20', '50', '100', '200', '500', '1000', '10000'];

export interface TableProps<T> extends Omit<AntdTableProps<T>, 'columns' | 'title'> {
  actions?: React.ReactElement;
  columns: TableColumnType<T>[];
  visibleData: readonly T[];
  setVisibleData: (data: readonly T[]) => void;
}

export function Table<T extends object>(props: TableProps<T>) {
  const { loading, actions, dataSource, onChange, setVisibleData, visibleData } = props;

  useEffect(() => {
    setVisibleData([]);
  }, [dataSource, setVisibleData]);

  const handleChange = (
    paging: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorters: SorterResult<T> | SorterResult<T>[],
    extra: TableCurrentDataSource<T>,
  ) => {
    setVisibleData(extra.currentDataSource);
    onChange && onChange(paging, filters, sorters, extra);
  };

  return (
    <AntdTable<T>
      {...props}
      title={(current) => {
        if (current.length > 0 && visibleData.length === 0) {
          setTimeout(() => setVisibleData(current), 0);
        }

        return <Space>{actions}</Space>;
      }}
      scroll={props.scroll === undefined ? { x: 'auto' } : props.scroll}
      pagination={{
        defaultPageSize: DEFAULT_PAGE_SIZE,
        pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
        showSizeChanger: true,
        ...(props.pagination ?? {}),
      }}
      loading={loading}
      onChange={handleChange}
    />
  );
}
